import { render, staticRenderFns } from "./edit-admin.vue?vue&type=template&id=3f366278&scoped=true&"
import script from "./edit-admin.vue?vue&type=script&lang=js&"
export * from "./edit-admin.vue?vue&type=script&lang=js&"
import style0 from "./edit-admin.vue?vue&type=style&index=0&id=3f366278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f366278",
  null
  
)

export default component.exports